export const MAX_ROW_HEIGHT = 44;

export const ICON_SIZE = 48;
export const MOBILE_ICON_SIZE = 32;

export const BANNER_STORAGE_KEYS = {
  storageWarning: 'storage-warning-banner',
} as const;
